<template>
  <div class="vc-add-resource-body">
    <div class="vc-add-resource-field">
      <span class="vc-form-label">类型</span>
      <div class="vc-add-resource-type">
        <Icon type="ios-mic" size="18" class="vc-add-resource-type__icon" />
        <span>语音合成</span>
      </div>
    </div>
    <div class="vc-add-resource-field">
      <span class="vc-form-label vc-form-label--required">名称</span>
      <Input v-model="form.name" placeholder="给资源取个名字" :maxlength="60" />
    </div>
    <div class="vc-add-resource-field">
      <span class="vc-form-label vc-form-label--required">供应商</span>
      <Select v-model="form.provider" transfer placeholder="请选择">
        <Option v-for="item in providers" :key="item" :value="item">{{ item }}</Option>
      </Select>
    </div>
    <div class="vc-add-resource-field">
      <span class="vc-form-label vc-form-label--required">group_id</span>
      <Input v-model="form.group_id" placeholder="请输入" />
    </div>
    <div class="vc-add-resource-field">
      <span class="vc-form-label vc-form-label--required">key</span>
      <Input v-model="form.key" placeholder="请输入" />
    </div>
    <div class="vc-add-resource-field">
      <span class="vc-form-label vc-form-label--required">描述</span>
      <Input
        v-model="form.description"
        type="textarea"
        :rows="3"
        placeholder="简单描述资源的功能，这将展示给用户"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddTtsResourceFields',
  props: {
    form: {
      type: Object,
      required: true,
    },
    providers: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
@import './shared.scss';

.vc-add-resource-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vc-add-resource-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vc-add-resource-type {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #0066a1;
  border-radius: 4px;
  color: #0066a1;
  font-size: 14px;
  background: #f5faff;
  width: fit-content;

  &__icon {
    color: #0066a1;
  }
}
</style>
